import React from 'react';
import "../../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Administration</h1>
                <p>Home &gt; Administration &gt; Wardens</p>
            </div>
        </div>
    )
}

export default Hero;